import { roles } from '@/configs/permissions'
import { AccessControl } from 'accesscontrol'

export const accessControl = new AccessControl(roles)
accessControl.lock()
